// Import dependencies
import initialiser from '../../utils/initialiser';

const defaultSettings = {
  selectClass: 'is-selected',
};

class PackageSelector {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;
    this.options = [...el.querySelectorAll(settings.option)];
    this.contents = [...el.querySelectorAll(settings.content)];
    this.contentInit = el.querySelector(settings.contentInit);

    // Set settings
    this.settings = { ...defaultSettings, ...settings };
  }

  // Initialisation Function
  init = () => {
    if (this.options.length <= 0 || this.contents.length <= 0) return;
    this.bindEvents();
  };

  bindEvents = () => {
    this.options.forEach((el) => {
      el.addEventListener('change', (ev) => {
        this.hideContents();

        // Find correct contents
        const contents = this.contents.find((c) => c.getAttribute('data-pack-id') === ev.target.value);

        if (contents) {
          contents.classList.add(this.settings.selectClass);
          this.contentInit.style.display = 'none';
        }
      });
    });
  };

  hideContents = () => {
    this.contents.forEach((el) => el.classList.remove(this.settings.selectClass));
  };
}

export default (settings) => initialiser(settings, PackageSelector);
